<div class="ui-g">
   <!-- <div class="ui-g-12 p-p-0">
        <p><strong>Filter</strong></p>
    </div>
    -->
    <div class="ui-g-12 ui-md-8 ui-lg-10" id="myTextField">
        <p-accordion [activeIndex]="0">
            <p-accordionTab header="Filter">
                <!--<p-chips [(ngModel)]="filterAccounts" id="myTextField">
                    <ng-template let-item pTemplate="item" id="myTextField">
                        {{item.name}}  <i class="pi pi-user ml-2"></i>
                    </ng-template>
                </p-chips>-->
                <div class="my-chip-box">
                    <div class="my-chip" *ngFor="let col of filterAccounts">
                        <div class="my-chip-content" pTooltip="{{ col.desc }}" tooltipPosition="top" [escape]="false">
                            <span>{{ col.name }}</span>
                        </div>
                        <div class="my-chip-close" (click)="this.removeAccounts(col.id)">
                            <svg class="my-chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z">
                                </path>
                            </svg>
        
                        </div>
                    </div>
                </div>
        
            </p-accordionTab>
        </p-accordion>
       
        <!--<p-chips 
            [(ngModel)]="filterAccounts"
            allowDuplicate="false"
            field="name"
            (onRemove)="this.removeAccount()"
        >
            <ng-template let-item pTemplate="item">
                <div
                    pTooltip="{{ item.desc }}"
                    tooltipPosition="top"
                    [escape]="false"
                >
                    <span>{{ item.name }}</span>
                </div>
            </ng-template>
        </p-chips>
    -->
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2 p-text-left">
        <button
            pButton
            class="p-ml-2"
            icon="ui-icon-touch-app"
            label="Pick"
            (click)="openFilterPicker()"
        ></button>
    </div>

    <p-dialog
        header="Report Filter"
        [(visible)]="displayFilter"
        *ngIf="displayFilter"
        [style]="{ width: '50%', align: 'center' }"
        appendTo="body"
        [resizable]="true"
        [maximizable]="true"
        [closeOnEscape]="true"
    >
        <div class="ui-g">
            <div class="ui-g-12">
                <tree-table
                    [inputTreeNodes]="accountsForFilter"
                    [treeColumns]="tableColumns"
                    [loadingTreeNodes]="loading"
                    selectionMode="multiple"
                    [(selected)]="selectedInFilter"
                ></tree-table>
            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-12">
                <button
                    type="button"
                    label="OK"
                    pButton
                    icon="ui-icon-check"
                    (click)="this.addAccountToFilter()"
                    style="margin-right: 0.5em"
                ></button>
                <button
                    type="button"
                    label="Cancel"
                    pButton
                    icon="ui-icon-cancel"
                    (click)="displayFilter = false"
                ></button>
            </div>
        </div>
    </p-dialog>
</div>
